export const environment = {
  production: true,
   //url: "https://vmuat.hfsgroup.in/hfs_visakhaDairy/tab" // UAT
  url: "https://vdpu.hfsgroup.in/hfs_visakhaDairy/tab" // PROD
};
